import { render, staticRenderFns } from "./moduleInfo.vue?vue&type=template&id=68dd0372&scoped=true&"
import script from "./moduleInfo.vue?vue&type=script&lang=js&"
export * from "./moduleInfo.vue?vue&type=script&lang=js&"
import style0 from "./moduleInfo.vue?vue&type=style&index=0&id=68dd0372&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68dd0372",
  null
  
)

export default component.exports